export default __webpack_public_path__ + "static/media/facebook.ac5bfe1b.svg";